import React, { useEffect } from 'react'
import { ProgressState } from '../../../components/progressState'


const ProgressCondition =({person, children, isBereau}) => {

    const isGreaterThanCreditBureauAnalysed = [
        ProgressState.CreditBureauAnalysed,
        ProgressState.EligibilityCalculated,
        ProgressState.LoanSummaryCalculated,
        ProgressState.MandateInitiated,
        ProgressState.MandateApproved,
        ProgressState.Approved,
        ProgressState.PendingDisbursement,
        ProgressState.Disbursed,
        ProgressState.Declined
      ].includes(person.loanApplicationProgressState);
    
      const isGreaterThanLoanSummaryCalculated = [
        ProgressState.LoanSummaryCalculated,
        ProgressState.MandateInitiated,
        ProgressState.MandateApproved,
        ProgressState.Approved,
        ProgressState.PendingDisbursement,
        ProgressState.Disbursed,
        ProgressState.Declined
      ].includes(person.loanApplicationProgressState);

      useEffect(() => {
        console.log(isGreaterThanLoanSummaryCalculated)
      }, [])

  return (
  <div>
  {
    isBereau ? (<span>
        {isGreaterThanCreditBureauAnalysed ? children : "N/A"} </span>
     ) : (  <span>
        {isGreaterThanLoanSummaryCalculated ? children : "N/A"}
      </span>)
  }
  </div>
  )
}

export default ProgressCondition